import {AfterViewInit, Component} from '@angular/core';
import {MessageComponent} from './message-component';

@Component({
    template: '',
    standalone: false
})
export abstract class ImmediatelyRenderedMessageComponent extends MessageComponent implements AfterViewInit {
    public ngAfterViewInit(): void {
        this.componentRenderingCompleted();
    }
}
